import FieldInput from 'common-form/components/FieldInput';

export default class AddressInput extends FieldInput {

    static defaultProps = {
        placeholder: "e.g. 12 Main Street"
    };
}